import { render, staticRenderFns } from "./SvgQuestion.vue?vue&type=template&id=3ec9514c&scoped=true"
import script from "./SvgQuestion.vue?vue&type=script&lang=ts"
export * from "./SvgQuestion.vue?vue&type=script&lang=ts"
import style0 from "./SvgQuestion.vue?vue&type=style&index=0&id=3ec9514c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9514c",
  null
  
)

export default component.exports